import React from "react";
import "./CompanyOverview.css";

const CompanyOverview = () => {
  return (
    <div className="company_overview_parent_div">
      <h2>Company Overview</h2>
      <p>
        M/S SAR ENTERPRISE is a partnership firm established in 2024, dedicated
        to providing top-notch construction services.
      </p>
      <p>📍 Head Office: House No 20/5, West Manikdi, Dhaka 1206.</p>
      <p>
        📍 Branch Office: House 28-30, West Avenue Road, Sector 16/B, Uttara New
        Market, Uttara, Dhaka 1230.
      </p>
      <p>📞 Phone: 01712-874402, 01716-532061, 01872-632259.</p>
      <p>📧 Email: mssarenterprise2024@gmail.com</p>

      <p>🌐 Website: www.sarenterprise.com</p>
    </div>
  );
};

export default CompanyOverview;
